import type { BizIconProps } from './base';
import BizIconSvg from './base';

/**
 * IconSampling — 抽检：放大镜 + 镜内勾选，表达抽检复核（icon-map.md §3.2 ⑦）。
 * 镜体比例对齐 Arco IconSearch（48 视口等比迁移），镜内加勾选区分"核验通过"语义。
 */
export default function IconSampling(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <circle cx="7.25" cy="7.25" r="3.77" />
      <path d="M10.55 10.55 13.85 13.85" />
      <path d="M6.2 7.5l1 1 1.6-2" />
    </BizIconSvg>
  );
}
